const getChunksFromString = (st: string, chunkSize: number) => st.match(new RegExp(`.{${chunkSize}}`, 'g'))!;

const convertHexUnitTo256 = (hexStr: string) => parseInt(hexStr.repeat(2 / hexStr.length), 16);

const getAlphaFloat = (a: number, alpha: number) => {
  if (typeof a !== 'undefined') {
    return a / 255;
  }

  if (alpha < 0 || alpha > 1) {
    return 1;
  }

  return alpha;
};

export function hexToRgba(hex: string, alpha?: number) {
  const chunkSize = Math.floor((hex.length - 1) / 3);
  const hexArr = getChunksFromString(hex.slice(1), chunkSize);
  const [r, g, b, a] = hexArr.map(convertHexUnitTo256);

  if (alpha === undefined) {
    return `rgb(${r}, ${g}, ${b})`;
  }

  return `rgba(${r}, ${g}, ${b}, ${getAlphaFloat(a, alpha)})`;
}

hexToRgba.isValidHex = (possiblyHex: string): boolean => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(possiblyHex);
